<template>
  <div>
    <side-bar>
      <template v-slot:header>
<!--          <template slot="extension">
            <v-text-field v-model="search" hide-details prepend-icon="search" single-line style="min-height: 25px; padding-top: 0;"></v-text-field>
          </template>-->
          <v-icon>movie</v-icon>
          <v-toolbar-title style="font-size: 16px;">Select channels</v-toolbar-title>

      </template>

      <template v-slot:subheader>
        <v-text-field
          :dark="$dark()"
          flat
          label="Search"
          prepend-inner-icon="search"
          solo
          hide-details
          v-model="search"
          color="deep-orange"
        ></v-text-field>
      </template>

<!--
    <v-card flat v-if="ready">
        <v-toolbar :dark="$dark()" light flat dense extended>
          <template slot="extension">
            <v-text-field v-model="search" hide-details prepend-icon="search" single-line style="min-height: 25px; padding-top: 0;"></v-text-field>
          </template>
          <v-icon>movie</v-icon>
          <v-toolbar-title style="font-size: 16px;">Select channels</v-toolbar-title>
        </v-toolbar>-->

        <v-list dense two-line>
          <template v-for="channel in filtered_channels">
            <v-list-tile @click.stop="toggleChannelFilter(channel)">
              <v-list-tile-content :class="{'grey--text text--darken-1': !is_running(channel)}">
                <v-list-tile-title>{{title(channel)}}</v-list-tile-title>
                <v-list-tile-sub-title class="grey--text" :class="{'text--darken-1': is_running(channel)}" style="text-transform: capitalize;">{{channel.state}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon v-if="is_visible(channel)" color="#f8d84a">fa-eye</v-icon>
                <v-icon v-if="!is_visible(channel)">fa-eye-slash</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
    </side-bar>

<!--      </v-card>-->
  </div>
</template>
<script>
  import ChannelModel from '@/models/channel.js';
  import InstanceModel from '@/models/instance.js';
  import naturalSort from 'natural-sort'
  import SideBar from '@/components/SideBar';

  export default {
    props: ['monitorType'],
    components: {
      SideBar
    },
    data () {
      return {
        naturalSort: naturalSort(),
        search: "",
        ready: false,
      }
    },
    computed: {
      instances() {
        return this.$store.state.instances;
      },
      system_channels () {
        return _.filter(this.channels, (channel) => { return _.get(channel, "channel.meta.system_channel", false); }).sort((a,b) => {
          var aTitle = _.get(a, "channel.title", "");
          var bTitle = _.get(b, "channel.title", "");
          return this.naturalSort(aTitle, bTitle);
        });
      },
      default_channels () {
        return _.filter(this.channels, (channel) => { 
          var instance = ChannelModel.instance(channel.channel, null);
          if (_.get(instance, "meta.is_developer", false) == true) return false;
          return !_.get(channel, "channel.meta.system_channel", false); 
        }).sort((a,b) => {
          var aTitle = _.get(a, "channel.title", "");
          var bTitle = _.get(b, "channel.title", "");
          return this.is_running(b) - this.is_running(a) || this.naturalSort(aTitle, bTitle);
        })
      },
      filtered_channels() {
        var channels = [];
        if(!this.monitorType) channels = this.default_channels;
        if(this.monitorType == "system") channels = this.system_channels;

        if(this.search.length < 3) return channels;
        return _.filter(channels, (channel) => {
          return _.get(channel, "channel.title", "").toLowerCase().includes(this.search.toLowerCase());
        });
      },
      channels () {
        var st = ChannelModel.status_all();
        if (typeof(st) != "undefined") {
          var res = [];
          _.each(st, (data, id) => {
            var headend = this.instances[data.headend_instance];
            var state = (this.get_source_state(data)||{}).state;
            if (typeof(headend) != "undefined") {
              var channel = ChannelModel.channel_by_uuid(id);
              if(channel) res.push({key: id, state: state, channel: channel});
            }
          });
          return res;
        }
        return [];
      },
      monitor_filters () {
        return this.$store.state.account.meta.monitor_channel_filter ||[];
      }
    },
    methods: {
      title(channel) {
        return _.get(channel, "channel.title", "")
      },
      toggleChannelFilter(channel) {
        var acc = _.cloneDeep(this.$store.state.account);
        acc.meta.monitor_channel_filter = _.xor(acc.meta.monitor_channel_filter, [channel.key]);
        this.$store.dispatch("update_profile", acc);
      },
      is_running(channel) {
        return channel.state != "listening";
      },
      is_visible(channel) {
        return typeof(_.find(this.monitor_filters, (uuid) => { return uuid == channel.key; })) != "undefined";
      },
      get_state(data, type) {
        var i = data.instance;
        if (typeof(i) != "undefined") {
          var s = i[type];
          if (typeof(s) != "undefined") {
            return s;
          }
        }
        return;
      },

      get_source_state(data) {
        return this.get_state(data, "source");
      }
    },
    mounted() {
      this.$store.dispatch("get_profile").then(() => {
        this.ready = true;
      }, () => {});
    }
  }
</script>